/**
 * Application version and build metadata.
 * Source of truth for the version number: root `package.json` → `version`.
 * Vite injects these constants at build / transform time (see vite.config.ts).
 */

export const APP_VERSION: string =
  typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0'

/** ISO timestamp of the frontend build (or Vite start in DEV). */
export const APP_BUILD_TIME: string =
  typeof __APP_BUILD_TIME__ !== 'undefined' ? __APP_BUILD_TIME__ : new Date().toISOString()

/** Explicit deployment label when defined; otherwise Vite mode. */
export const APP_ENVIRONMENT: string =
  typeof __APP_ENVIRONMENT__ !== 'undefined' ? __APP_ENVIRONMENT__ : 'development'
